import React from 'react';
import Icon from '../../../components/AppIcon';

const SlotMetricsOverview = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Active Slots',
      value: metrics?.totalActive,
      icon: 'Calendar',
      bgColor: 'bg-[#E6F0F5]',
      iconColor: 'text-[#002B45]',
      description: 'All Monday slots'
    },
    {
      label: 'Available Slots',
      value: metrics?.available,
      icon: 'CheckCircle',
      bgColor: 'bg-[#D1F5F0]',
      iconColor: 'text-[#1FB5A5]',
      description: 'Ready for booking'
    },
    {
      label: 'Booked Slots',
      value: metrics?.booked,
      icon: 'UserCheck',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-600',
      description: 'Confirmed bookings'
    },
    {
      label: 'Blocked Slots',
      value: metrics?.blocked,
      icon: 'XCircle',
      bgColor: 'bg-red-50',
      iconColor: 'text-red-600',
      description: 'Unavailable slots'
    },
    {
      label: 'Week Coverage',
      value: metrics?.weeksCovered,
      icon: 'CalendarDays',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-600',
      description: 'Weeks with slots'
    },
    {
      label: 'Utilization Rate',
      value: `${metrics?.utilizationRate}%`,
      icon: 'TrendingUp',
      bgColor: 'bg-orange-50',
      iconColor: 'text-orange-600',
      description: 'Booking efficiency'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
      {metricCards?.map((metric, index) => (
        <div 
          key={index}
          className="bg-white rounded-xl shadow-elevation-1 p-6 hover:shadow-elevation-2 transition-shadow duration-300"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 ${metric?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.iconColor} />
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">{metric?.value}</p>
            <p className="text-sm font-medium text-foreground mb-1">{metric?.label}</p>
            <p className="text-xs text-muted-foreground">{metric?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SlotMetricsOverview;